//
// Video floating strategy.
function AdsNinjaFloatingStrategySingleNonOutstreamVideo(logger, options = {}, callbacks = {}){

    AdsNinjaFloatingStrategySingleVideo.call(this, logger, options, callbacks);
}

AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype             = Object.create(AdsNinjaFloatingStrategySingleVideo.prototype);
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype.constructor = AdsNinjaFloatingStrategySingleNonOutstreamVideo;

//
// Handle request to float.
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype.handleRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var foundInfo = state[requestDetails.originalElementId];

    if(foundInfo){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Float request rejected. Ad is already floating.', returnResult);

        return returnResult;
    }

    var allAdsDefloated = true;
    var returnResult    = null;

    // Validate requestor is the user if an element is currently showing.
    var currentlyShowingUserRequestedElement = adTypeMapping[requestDetails.adType].some(function(element){

        return (element.requestor === window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER); 
    });

    if(currentlyShowingUserRequestedElement && requestDetails.requestor !== window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER){

        floatAdTypeRequestQueue[requestDetails.adType].push(requestDetails);
        floatPositionRequestQueue[requestDetails.position].push(requestDetails);

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.debug('Float request failed. User is not the requestor.', returnResult);

        return returnResult;
    } 

    var indexOfDisabledElement = disabledElements.indexOf(requestDetails.originalElementId);
    
    if(-1 !== indexOfDisabledElement){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.debug('Float request failed. Element is not allowed to float.', returnResult);

        return returnResult;
    }

    if(!this.__shouldElementBeIgnored(requestDetails.originalElementId)){

        for(var i = 0; i < adTypeMapping[requestDetails.adType].length; i++){

            var foundelementId = adTypeMapping[requestDetails.adType][i];
            var defloatInfo    = state[foundelementId];

            if(!defloatInfo){

                this.__logger.warn(`No defloating info found for element ID: ${foundelementId}.`);

                delete state[foundelementId];
                delete adTypeMapping[requestDetails.adType][i];
                
                positionMapping[requestDetails.position] = null;

                continue;
            }

            // Ignore outstream elements.
            if(this.__shouldElementBeIgnored(defloatInfo.originalElementId)){

                continue;
            }

            var defloatRequestDetails = {
                elementId: defloatInfo.originalElementId, 
                adType: defloatInfo.adType, 
                position: defloatInfo.position, 
                floatType: defloatInfo.floatType, 
                requestor: defloatInfo.requestor, 
                context: window.AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND,
                floatCallback: defloatInfo.floatCallback,
                defloatCallback: defloatInfo.defloatCallback,
            };

            // Defloat old element.
            var defloatResult = this.handleRequestToDefloat(
                defloatRequestDetails,
                adTypeMapping,
                floatAdTypeRequestQueue,
                positionMapping,
                floatPositionRequestQueue,
                state,
                disabledElements,
                false
            ); 

            defloatRequestDetails     = defloatResult.requestDetails;
            adTypeMapping             = defloatResult.adTypeMapping; 
            floatAdTypeRequestQueue   = defloatResult.floatAdTypeRequestQueue;
            positionMapping           = defloatResult.positionMapping;
            floatPositionRequestQueue = defloatResult.floatPositionRequestQueue;
            state                     = defloatResult.state;
            disabledElements          = defloatResult.disabledElements;
            allAdsDefloated           = (allAdsDefloated && defloatResult.requestApproved);

            if(!defloatResult.requestApproved){

                continue;
            }

            // Add element to queues.
            var updateQueuesResult    = this._updateStateAfterPriorityRequestToFloat(defloatRequestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
            defloatRequestDetails     = updateQueuesResult.requestDetails;
            adTypeMapping             = updateQueuesResult.adTypeMapping;
            floatAdTypeRequestQueue   = updateQueuesResult.floatAdTypeRequestQueue;
            positionMapping           = updateQueuesResult.positionMapping;
            floatPositionRequestQueue = updateQueuesResult.floatPositionRequestQueue;
            state                     = updateQueuesResult.state;
            disabledElements          = updateQueuesResult.disabledElements;
        }
    }

    if(!allAdsDefloated){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Float request failed. All ads were not defloated.', returnResult);

        return returnResult;
    }

    var floatResult = requestDetails.floatCallback(requestDetails.context);

    if(floatResult !== null && !floatResult){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        // TODO: Fallback.
        this.__logger.warn('Float request failed. No fallback implemented.', returnResult);

        // // TODO: Defloat.
        // // TODO: Try to float previous one.
        // var floatFallbackResult = this.requestToFloat(
        //     currentInfo['elementId'], 
        //     currentInfo['adType'], 
        //     currentInfo['position'], 
        //     currentInfo['floatType'], 
        //     this.REQUESTOR_MANAGER, 
        //     floatCallback, 
        //     defloatCallback
        // );
        // if(floatFallbackResult){

        //     this.__logger.warn('Float request failed. Fallback to float request was successful.', {
        //         elementId: elementId,
        //         adType: adType,
        //         position: position,
        //         requestor: requestor,
        //         floatType: floatType,
        //         floatCallback: floatCallback,
        //         defloatCallback: defloatCallback,   
        //     });
        // }
        // else{

        //     this.__logger.warn('Float request failed. Fallback to float request was not successful.', {
        //         elementId: elementId,
        //         adType: adType,
        //         position: position,
        //         requestor: requestor,
        //         floatType: floatType,
        //         floatCallback: floatCallback,
        //         defloatCallback: defloatCallback,   
        //     });
        // }

        return returnResult;
    }

    var updatedStateResult    = this._updateStateAfterRequestToFloat(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    requestDetails            = updatedStateResult.requestDetails;
    adTypeMapping             = updatedStateResult.adTypeMapping;
    floatAdTypeRequestQueue   = updatedStateResult.floatAdTypeRequestQueue;
    positionMapping           = updatedStateResult.positionMapping;
    floatPositionRequestQueue = updatedStateResult.floatPositionRequestQueue;
    state                     = updatedStateResult.state;
    disabledElements          = updatedStateResult.disabledElements;

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Handle request to defloat.
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype.handleRequestToDefloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements, floatNextAvailableElement = true){

    if(this.__shouldElementBeIgnored(requestDetails.originalElementId)){

        return AdsNinjaFloatingStrategySingleVideo.prototype.handleRequestToDefloat.call(this, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements, false);
    }

    return AdsNinjaFloatingStrategySingleVideo.prototype.handleRequestToDefloat.call(this, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements, floatNextAvailableElement);
}

//
// Handle enable element.
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype.handleEnableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var parentResult = AdsNinjaFloatingStrategySingleVideo.prototype.handleEnableElement.call(this, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

    if(!parentResult){

        return {
            requestDetails: requestDetails,
            adTypeMapping: adTypeMapping,
            floatAdTypeRequestQueue: floatAdTypeRequestQueue,
            positionMapping: positionMapping,
            floatPositionRequestQueue: floatPositionRequestQueue,
            state: state,
            disabledElements: disabledElements,
        }
    }

    requestDetails            = parentResult.requestDetails;
    adTypeMapping             = parentResult.adTypeMapping;
    floatAdTypeRequestQueue   = parentResult.floatAdTypeRequestQueue;
    positionMapping           = parentResult.positionMapping;
    floatPositionRequestQueue = parentResult.floatPositionRequestQueue;
    state                     = parentResult.state;
    disabledElements          = parentResult.disabledElements;

    if(!this.__shouldElementBeIgnored(requestDetails.originalElementId)){

        for(var i = 0; i < adTypeMapping[requestDetails.adType].length; i++){

            var foundelementId = adTypeMapping[requestDetails.adType][i];
            var foundInfo      = state[foundelementId];

            if(!foundInfo || foundInfo.originalElementId === requestDetails.originalElementId){

                continue;
            }

            // Ignore outstream elements.
            if(this.__shouldElementBeIgnored(foundInfo.originalElementId)){

                continue;
            }

            var defloatRequestDetails = {
                elementId: foundInfo.originalElementId, 
                adType: foundInfo.adType, 
                position: foundInfo.position, 
                floatType: foundInfo.floatType, 
                requestor: requestDetails.requestor, 
                context: window.AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND,
                floatCallback: foundInfo.floatCallback,
                defloatCallback: foundInfo.defloatCallback,
            };

            // Defloat old element.
            var defloatResult = this.handleRequestToDefloat(
                defloatRequestDetails,
                adTypeMapping,
                floatAdTypeRequestQueue,
                positionMapping,
                floatPositionRequestQueue,
                state,
                disabledElements,
                false
            ); 

            defloatRequestDetails     = defloatResult.requestDetails;
            adTypeMapping             = defloatResult.adTypeMapping; 
            floatAdTypeRequestQueue   = defloatResult.floatAdTypeRequestQueue;
            positionMapping           = defloatResult.positionMapping;
            floatPositionRequestQueue = defloatResult.floatPositionRequestQueue;
            state                     = defloatResult.state;
            disabledElements          = defloatResult.disabledElements;

            // Disable old element.
            var disableResult = this.handleDisableElement(
                defloatRequestDetails,
                adTypeMapping,
                floatAdTypeRequestQueue,
                positionMapping,
                floatPositionRequestQueue,
                state,
                disabledElements
            );

            defloatRequestDetails     = disableResult.requestDetails;
            adTypeMapping             = disableResult.adTypeMapping;
            floatAdTypeRequestQueue   = disableResult.floatAdTypeRequestQueue;
            positionMapping           = disableResult.positionMapping;
            floatPositionRequestQueue = disableResult.floatPositionRequestQueue;
            state                     = disableResult.state;
            disabledElements          = disableResult.disabledElements;
        }
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    }
};

//
// Determine if element is to be ignored.
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype.__shouldElementBeIgnored = function(elementId){
            
    if(!this.__callbacks || !this.__callbacks.hasOwnProperty('getElementsToIgnore') || typeof this.__callbacks['getElementsToIgnore'] !== 'function'){

        return false;
    }

    var elementsToIgnore = this.__callbacks['getElementsToIgnore']();

    if(!elementsToIgnore || !Array.isArray(elementsToIgnore) || elementsToIgnore.length === 0){

        return false;
    }

    for(var i = 0; i < elementsToIgnore.length; i++){

        if(-1 !== elementsToIgnore[i].indexOf(elementId)){

            return true;
        }
    }   

    return false;
}

//
// Update state.
AdsNinjaFloatingStrategySingleNonOutstreamVideo.prototype._updateStateAfterPriorityRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){
    
    requestDetails.context = window.AdsNinjaFloatingManager.prototype.CONTEXT_RESUME;

    floatAdTypeRequestQueue[requestDetails.adType].unshift(requestDetails);
    floatPositionRequestQueue[requestDetails.position].unshift(requestDetails);

    if(-1 === disabledElements.indexOf(requestDetails.originalElementId)){
        
        disabledElements.push(requestDetails.originalElementId);
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

window.AdsNinjaFloatingStrategySingleNonOutstreamVideo = AdsNinjaFloatingStrategySingleNonOutstreamVideo;